import React, { useMemo } from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { LineChart, Line, XAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { format } from 'date-fns';

const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        return (
            <Box sx={{ bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider', p: 1, borderRadius: 1 }}>
                <Typography variant="caption" display="block">{`Date: ${format(new Date(label), 'MMM d, yyyy')}`}</Typography>
                <Typography variant="body2" sx={{ fontWeight: 'bold', color: payload[0].color }}>{`${payload[0].name}: ${payload[0].value}`}</Typography>
            </Box>
        );
    }
    return null;
};

export default function VitalsSparkline({ data, title, color }) {
    const chartData = useMemo(() =>
        (data || []).map(point => ({
            timestamp: new Date(point.timestamp).getTime(),
            value: point.value
        })),
    [data]);

    if (!data || data.length === 0) {
        return <Typography variant="caption" color="text.secondary">No data available</Typography>;
    }

    const latestValue = chartData.length > 0 ? chartData[chartData.length - 1].value : 'N/A';

    return (
        <Stack direction="row" alignItems="center" spacing={2} sx={{ width: '100%'}}>
            <Typography variant="body2" fontWeight="500" sx={{ minWidth: '120px' }}>
                {title}
            </Typography>
            <Typography variant="h6" fontWeight="bold" sx={{ minWidth: '60px', textAlign: 'right', color: color }}>
                {latestValue}
            </Typography>
            <Box sx={{ width: '100%', height: 40 }}>
                <ResponsiveContainer>
                    <LineChart data={chartData}>
                        <Tooltip content={<CustomTooltip />} />
                        <XAxis
                            dataKey="timestamp"
                            type="number"
                            domain={['dataMin', 'dataMax']}
                            tickFormatter={(unixTime) => format(new Date(unixTime), 'MMM d')}
                            hide
                        />
                        <Line
                            type="monotone"
                            dataKey="value"
                            stroke={color}
                            strokeWidth={2}
                            dot={false}
                            name={title}
                        />
                    </LineChart>
                </ResponsiveContainer>
            </Box>
        </Stack>
    );
}